<template>
  <v-card class="card-pad mx-auto" width="900px">
    <div class="d-flex justify-left my-3 px-4">
      <div>
        <h2>Histórico do Equipamento: {{ identification }}</h2>
        <span style="font-size: 12px">
          {{ $t('Criado em') }}: {{ formatDate(currentEquipment.create) }} por
          {{ currentEquipment.creationUser ? currentEquipment.creationUser.name : '' }}
          <br />
          {{ $t('Última alteração') }}:
          {{ formatDate(currentEquipment.update) }} por
          {{ currentEquipment.lastUpdateUser ? currentEquipment.lastUpdateUser.name : '' }}
        </span>
      </div>
        <div class="d-flex align-center legend-updated ml-auto">
        <span style="font-size: 13px; margin-right: 8px;">Dados atualizados</span>
        <span class="legend-square"></span>
      </div>
    </div>

    <v-list two-line>
      <template v-for="(log, index) in logs">
        <v-list-item :key="'item-' + log.changeDate + '-' + index">
          <v-list-item-content>
            <v-list-item-title>
              <span v-if="log.User && log.User.name">- {{ log.User.name }}</span>
            </v-list-item-title>
            <v-list-item-subtitle>
              Alteração realizada em {{ formatDate(log.changeDate) }} por
              {{ log.user ? log.user.name : '-' }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn class="primary-button" small @click="toggleDetails(index)">
              Detalhes
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-expand-transition :key="'expand-' + log.changeDate + '-' + index">
          <div v-if="expandedIndex === index" class="pa-3 grey lighten-4">
            <v-row>
              <v-col cols="12" sm="6">
                <div class="mb-2 text-center"><strong>Antes da alteração</strong></div>
                <div class="data-block pa-3 mb-2">
                  <div v-for="field in displayFields" :key="'before-' + field.key" style="line-height:1.2; margin-bottom:2px;">
                    <div style="font-weight:bold;">{{ field.label }}</div>
                    <div
                      :class="{
                        'changed-red': isFieldChanged(field.key, log.EquipmentBeforeChange, log.EquipmentAfterChange)
                      }"
                    >
                      <template v-if="field.key === 'ConservationState'">
                        {{ getConservationStateText(log.EquipmentBeforeChange ? log.EquipmentBeforeChange[field.key] : null) }}
                      </template>
                      <template v-else>
                        {{ formatFieldValue(log.EquipmentBeforeChange ? log.EquipmentBeforeChange[field.key] : '') }}
                      </template>
                    </div>
                  </div>       
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="mb-2 text-center"><strong>Depois da alteração</strong></div>
                <div class="data-block pa-3 mb-2">
                  <div v-for="field in displayFields" :key="'after-' + field.key" style="line-height:1.2; margin-bottom:2px;">
                    <div style="font-weight:bold;">{{ field.label }}</div>
                    <div
                      :class="{
                        'changed-red': isFieldChanged(field.key, log.EquipmentBeforeChange, log.EquipmentAfterChange)
                      }"
                    >
                      <template v-if="field.key === 'ConservationState'">
                        {{ getConservationStateText(log.EquipmentAfterChange ? log.EquipmentAfterChange[field.key] : null) }}
                      </template>
                      <template v-else>
                        {{ formatFieldValue(log.EquipmentAfterChange ? log.EquipmentAfterChange[field.key] : '') }}
                      </template>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>
      </template>
    </v-list>

    <div v-if="!logs || logs.length === 0" class="pa-4 text-center grey--text">
      Nenhuma alteração encontrada.
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'EquipmentHistory',
  props: {
    equipmentId: {
      type: [Number, String],
      required: true,
    },
    institutionId: {
      type: [Number, String],
      required: true,
    },
    identification: { type: String, required: false },
    currentEquipment: { type: Object, required: false, default: () => ({}) }
  },
  data() {
    return {
      logs: [],
      expandedIndex: null,
      loading: false,
      error: false,
      errorMessage: '',
      displayFields: [
        { key: 'Name', label: 'Nome' },
        { key: 'Identification', label: 'Identificação' },
        { key: 'SerialNumber', label: 'Nº de Série' },
        { key: 'Model', label: 'Modelo' },
        { key: 'Manufacturer', label: 'Fabricante' },
        { key: 'PropertyCode', label: 'Código Patrimônio' },
        { key: 'Location', label: 'Localização' },
        { key: 'PurchaseDate', label: 'Data de Compra' },
        { key: 'PurchasePrice', label: 'Valor de Compra' },
        { key: 'Criticality', label: 'Criticidade' },
        { key: 'LifeExpectancy', label: 'Exp. Vida' },
        { key: 'ConservationState', label: 'Estado de Conservação' },
        { key: 'DegreeImportance', label: 'Grau de Importância' },
        { key: 'WarrantyStartDate', label: 'Início Garantia' },
        { key: 'WarrantyEndDate', label: 'Término Garantia' },
        { key: 'Manuals', label: 'Manuais' },
        { key: 'Accessories', label: 'Acessórios' },
        { key: 'Observation', label: 'Observações' },
        { key: 'Invoice', label: 'Nota Fiscal' },
      ],
      conservationStates: [
      { text: 'Bom', value: 0 },
      { text: 'Ruim', value: 1 },
      { text: 'Péssimo', value: 2 },
      ],
    }
  },
  created() {
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
        console.log(this.equipmentId, this.institutionId)
      this.loading = true
      this.error = false
      try {
        const ApiService = (await import('../../../../../services/ApiService.js')).default
        const api = new ApiService()
        const response = await api.get(`equipment/${this.institutionId}/${this.equipmentId}/logs`)
        this.logs = (response.content || []).map(log => ({
          ...log,
          EquipmentBeforeChange: typeof log.equipmentBeforeChange === 'string' && log.equipmentBeforeChange.trim() !== ''
            ? JSON.parse(log.equipmentBeforeChange)
            : log.equipmentBeforeChange,
          EquipmentAfterChange: typeof log.equipmentAfterChange === 'string' && log.equipmentAfterChange.trim() !== ''
            ? JSON.parse(log.equipmentAfterChange)
            : log.equipmentAfterChange,
        }))
      } catch (err) {
        this.error = true
        this.errorMessage = (err && err.body && err.body.message) || err.message || 'Erro ao buscar logs.'
      }
      this.loading = false
    },
    toggleDetails(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleString('pt-BR')
    },
    formatFieldValue(value) {
      if (value === null) return '-'
      if (value === undefined) return '-'
      if (value === '') return '-'
      // Tenta detectar datas ISO e formatar
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) {
        const d = new Date(value)
        if (!isNaN(d)) return d.toLocaleDateString('pt-BR')
      }
      return value
    },

    getConservationStateText(value) {
    const state = this.conservationStates.find(s => s.value === value);
    return state ? state.text : '-';
    },

    isFieldChanged(key, before, after) {
    if (!before || !after) return false;
    return (before[key] || '') !== (after[key] || '');
    },
  }
}
</script>

<style scoped>
.compact-list-item-title {
  line-height: 1;
  margin: 0;
  padding: 0;
}
.data-block {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  border: 1px solid #eee;
}

.changed-red {
  color: #BBCF20;
  font-weight: bold;
}
.legend-updated {
  margin-left: 16px;
}
.legend-square {
  width: 18px;
  height: 18px;
  background: #BBCF20;
  border-radius: 4px;
  display: inline-block;
  border: 1px solid #BBCF20;
}
</style>